import { type DisplaySettings } from '../components/DisplayCustomizationDrawer/index'

const STORAGE_KEY = 'displaySettings'

export function formatReportPayload (
  data: DisplaySettings
): { calculations: string[], compareIds: any[] } {
  return {
    calculations: Object.keys(data.keyStatistics || {}).filter(
      key => data.keyStatistics[key]
    ),
    compareIds: (data.comparisons || [])
      .filter(item => item.comparison)
      .map(item => item.comparison)
  }
}

export function saveDisplaySettings (settings: DisplaySettings): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(settings))
}

export function loadDisplaySettings (getDefaultSettings: () => DisplaySettings): DisplaySettings {
  const stored = localStorage.getItem(STORAGE_KEY)
  if (stored) {
    try {
      return JSON.parse(stored)
    } catch {}
  }
  return getDefaultSettings()
}

export function getFinalReportPayload (
  payload?: Record<string, any>,
  settings?: any
): Record<string, any> {
  if (payload && Object.keys(payload).length > 0) {
    return payload
  }
  return formatReportPayload(settings) ?? {}
}
